// TODO: Implement this
// accept content and contentType

import { GET_POINTS_OF_INTEREST } from '../constants';

async function fetchPointsOfInterest(
  content: string,
  contentType: string,
  accessToken: string
): Promise<any> {
  if (!content || !contentType || !accessToken) {
    throw new Error('Invalid arguments');
  }
  const response = await fetch(GET_POINTS_OF_INTEREST, {
    method: 'POST',
    headers: {
      'authorization': `Bearer ${accessToken}`,
      'content-type': 'application/json',
    },
    body: JSON.stringify({ content, contentType }),
  });

  const data = await response.json();

  return data;
}

export { fetchPointsOfInterest };
